import "./Button.css";

const Button = ({
  children,
  onClick,
  type = "button",
  disable = false
}) => {
  return (
    <>
      <button className={`common-btn`}
        type={type}
        onClick={onClick}
        disabled={disable}
      >
        {children}
      </button>
    </>
  )
}
export default Button;